import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3 text-center">
            Vigorbuy Spreadsheet vs Manual Browsing
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-3 max-w-lg mx-auto">
            See how spreadsheet-based product discovery compares to traditional online shopping methods.
          </p>
          <p className="text-center mb-10">
            <Link
              to="/kakobuy-vs-vigorbuy"
              className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
            >
              Also see: Kakobuy vs Vigorbuy detailed comparison
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </p>

          <div className="overflow-x-auto">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="border-b-2 border-background-300/60">
                  <th className="text-left py-3 px-4 font-semibold text-foreground-900">Feature</th>
                  <th className="text-center py-3 px-4 font-semibold text-accent-700 bg-accent-50/50 rounded-t-lg">Vigorbuy Spreadsheet</th>
                  <th className="text-center py-3 px-4 font-semibold text-foreground-600">Manual Browsing</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-background-200/70">
                {[
                  { feature: "Product Database Size", vigorbuy: "Extensive", manual: "Limited by search" },
                  { feature: "Category Coverage", vigorbuy: "14+ Categories", manual: "Single category" },
                  { feature: "Beginner Experience", vigorbuy: "Very Easy", manual: "Moderate" },
                  { feature: "Comparison Speed", vigorbuy: "Seconds", manual: "Minutes to hours" },
                  { feature: "Organization Level", vigorbuy: "Fully Structured", manual: "Unstructured" },
                  { feature: "Update Frequency", vigorbuy: "Regular", manual: "Manual refresh" },
                  { feature: "Shopping Guides", vigorbuy: "Included", manual: "Separate search" },
                  { feature: "Product Research Depth", vigorbuy: "Comprehensive", manual: "Surface level" },
                ].map((row) => (
                  <tr key={row.feature}>
                    <td className="py-3 px-4 font-medium text-foreground-800">{row.feature}</td>
                    <td className="py-3 px-4 text-center text-accent-700 bg-accent-50/30 font-semibold">{row.vigorbuy}</td>
                    <td className="py-3 px-4 text-center text-foreground-600">{row.manual}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-10 text-center">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              Try Vigorbuy Spreadsheet Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}